import { render, staticRenderFns } from "./FullScreenContainer.vue?vue&type=template&id=15311179&scoped=true"
import script from "./FullScreenContainer.vue?vue&type=script&lang=js"
export * from "./FullScreenContainer.vue?vue&type=script&lang=js"
import style0 from "./FullScreenContainer.vue?vue&type=style&index=0&id=15311179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15311179",
  null
  
)

export default component.exports